import React from 'react';
import { Wrapper } from './styled';
import { useDispatch, useSelector } from 'react-redux';
import { openModal } from 'store/modals/actions';
import { MODAL_AGENT_EXECUTOR_DETAIL } from 'store/modals/modals';
import { get } from 'lodash';
import { setAgentExecutorSeleted } from 'store/Agents/actions';
import { selectAgentExecutionType } from 'store/Agents/selectors';

const AgentCell = ({ rowInfo }) => {
  const agentType = useSelector(selectAgentExecutionType);
  const data = get(rowInfo, 'original', {});
  const name = get(data, agentType === 'agent_executions' ? 'agent_name' : 'cloud_agent_name', '');
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(setAgentExecutorSeleted(data));
    dispatch(openModal(MODAL_AGENT_EXECUTOR_DETAIL));
  };

  return <Wrapper title={ name } onClick={ onClick }>{name}</Wrapper>;
};

export default AgentCell;
